"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationHighHouseComposition = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 256 168",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#10105A",
            x: "0",
            y: "164",
            width: "256",
            height: "4",
            rx: "2"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M145.892336,34.5561244 C131.339846,34.0419533 117.478419,29.2483579 104.243769,24.0046128 C91.0091187,18.7608676 77.8970118,12.9489334 63.6940708,10.1700086 C54.5575821,8.38341396 44.1092799,8.13133007 36.748661,13.1269927 C29.6632617,17.9285907 27.3751217,26.2393565 26.1456733,33.9339173 C25.2195693,39.7358482 24.6751567,45.8278757 27.2103917,51.2536814 C28.9721992,55.0209352 32.1000605,58.1859885 34.2636485,61.793189 C41.7869886,74.3473671 36.4734413,89.8285194 28.3132792,102.086599 C24.4963644,107.836513 20.050663,113.322338 17.0995852,119.442375 C14.1485073,125.562412 12.7824536,132.576746 15.3638934,138.820824 C17.9252441,145.010884 24.0242723,149.658431 30.6315527,152.927519 C44.0530306,159.56973 59.8691204,161.470362 75.2914652,162.54672 C109.430755,164.929513 143.752855,163.89717 177.982546,162.864826 C190.650685,162.480698 203.373065,162.09457 215.836296,160.095905 C222.754957,158.985535 229.898614,157.224949 234.92087,152.971534 C241.299136,147.569736 242.880142,138.432695 238.605198,131.664443 C231.44346,120.314665 211.621619,117.497728 206.611416,105.309672 C203.853193,98.6034397 206.685745,91.1329535 210.693506,84.9028801 C219.291609,71.5604396 233.703475,59.8545438 234.462841,44.6014675 C234.985155,34.1259812 228.05645,23.6344896 217.344982,18.6788403 C206.115217,13.4771092 190.546222,14.1373289 182.261508,22.7361906 C173.731708,31.6051423 158.741277,35.0122762 145.892336,34.5561244 Z",
            className: "fill-primary",
            fill: "#1657E2",
            fillRule: "nonzero",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            opacity: "0.499488467",
            transform: "translate(47.000000, 106.000000)",
            className: "fill-primary",
            fill: "#0842C0",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M15.2419339,0 C28.1214369,25.7777778 32.8906677,45.1111111 29.5496262,58 C21.573538,58 13.6014812,58 0.934241627,58 C-2.20428343,45.1111111 2.56494733,25.7777778 15.2419339,0 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(31.000000, 106.000000)",
            className: "fill-primary",
            fill: "#0842C0",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M15.2419339,0 C28.1214369,25.7777778 32.8906677,45.1111111 29.5496262,58 C21.573538,58 13.6014812,58 0.934241627,58 C-2.20428343,45.1111111 2.56494733,25.7777778 15.2419339,0 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(25.000000, 0.000000)",
            className: "fill-secondary",
            fill: "#10105A",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              cx: "20",
              cy: "20",
              r: "20"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(70.000000, 15.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFFFFF",
                x: "0",
                y: "4.80645161",
                width: "67.0833333",
                height: "144.193548"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "67.0833333",
                y: "4.80645161",
                width: "47.9166667",
                height: "144.193548"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "0",
                y: "0",
                width: "67.0833333",
                height: "4.80645161"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#031432",
                x: "67.0833333",
                y: "0",
                width: "47.9166667",
                height: "4.80645161"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "9.58333333",
                y: "129.774194",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "9.58333333",
                y: "72.0967742",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "9.58333333",
                y: "110.548387",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "9.58333333",
                y: "52.8709677",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "28.75",
                y: "110.548387",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "28.75",
                y: "52.8709677",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "9.58333333",
                y: "91.3225806",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "9.58333333",
                y: "33.6451613",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "28.75",
                y: "91.3225806",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "28.75",
                y: "72.0967742",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "28.75",
                y: "14.4193548",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "47.9166667",
                y: "14.4193548",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "9.58333333",
                y: "14.4193548",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "28.75",
                y: "33.6451613",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "28.75",
                y: "129.774194",
                width: "9.58333333",
                height: "19.2258065"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "47.9166667",
                y: "129.774194",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "47.9166667",
                y: "72.0967742",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "76.6666667",
                y: "52.8709677",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "95.8333333",
                y: "52.8709677",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "47.9166667",
                y: "110.548387",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "47.9166667",
                y: "52.8709677",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "76.6666667",
                y: "33.6451613",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "95.8333333",
                y: "33.6451613",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "47.9166667",
                y: "91.3225806",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "47.9166667",
                y: "33.6451613",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "76.6666667",
                y: "14.4193548",
                width: "9.58333333",
                height: "9.61290323"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "95.8333333",
                y: "14.4193548",
                width: "9.58333333",
                height: "9.61290323"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(137.000000, 154.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,0 L0.295900454,0.0047585308 C5.30742742,0.166156746 9.34215109,4.4132343 9.4954794,9.68852584 L9.5,10 L9.20409955,9.99524147 C4.19257258,9.83384325 0.157848909,5.5867657 0.00452060426,0.311474163 L0,0 Z",
                className: "fill-primary",
                fill: "#1657E2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M19,0 L18.9954794,0.311474163 C18.8452177,5.48125987 14.9672638,9.66354887 10.0953967,9.98067922 L9.79590045,9.99524147 L9.5,10 L9.5045206,9.68852584 C9.65478234,4.51874013 13.5327362,0.336451134 18.4046033,0.0193207792 L18.7040995,0.0047585308 L19,0 Z",
                className: "fill-primary-opa50",
                fill: "#779DED"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(174.000000, 150.000000)",
            className: "fill-primary",
            fill: "#1657E2",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M0,14 C0,8.84534234 4.27816795,4.66666667 9.55555556,4.66666667 C12.0996841,4.66666667 14.4115919,5.63779985 16.1239165,7.22124707 C18.5666974,2.91514045 23.2681427,0 28.6666667,0 C36.4609622,0 42.8021913,6.0766351 42.9954613,13.6441961 L43,14 L0,14 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(11.000000, 10.000000)",
            fill: "#FFFFFF",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M43,14 C43,8.84534234 38.7218321,4.66666667 33.4444444,4.66666667 C30.9003159,4.66666667 28.5884081,5.63779985 26.8760835,7.22124707 C24.4333026,2.91514045 19.7318573,0 14.3333333,0 C6.53903779,0 0.197808658,6.0766351 0.00453871899,13.6441961 L0,14 L43,14 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(201.000000, 42.000000)",
            fill: "#FFFFFF",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M43,14 C43,8.84534234 38.7218321,4.66666667 33.4444444,4.66666667 C30.9003159,4.66666667 28.5884081,5.63779985 26.8760835,7.22124707 C24.4333026,2.91514045 19.7318573,0 14.3333333,0 C6.53903779,0 0.197808658,6.0766351 0.00453871899,13.6441961 L0,14 L43,14 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(22.500000, 73.000000) scale(-1, 1) translate(-22.500000, -73.000000) translate(1.000000, 66.000000)",
            fill: "#FFFFFF",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M43,14 C43,8.84534234 38.7218321,4.66666667 33.4444444,4.66666667 C30.9003159,4.66666667 28.5884081,5.63779985 26.8760835,7.22124707 C24.4333026,2.91514045 19.7318573,0 14.3333333,0 C6.53903779,0 0.197808658,6.0766351 0.00453871899,13.6441961 L0,14 L43,14 Z"
            })
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationHighHouseComposition')(IllustrationHighHouseComposition);